import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { DynamicMembershipForm } from './dynamic/DynamicMembershipForm.jsx';
import { ErrorMessage } from '../shared/ErrorMessage.jsx';
import I18n from 'i18n-js';
import '../translations.js';

export class NewExhibitorCompanyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: this.props.userData.first_name + ' ' + this.props.userData.last_name,
      contactName: '',
      taxId: '',
      email: '',
      password: '',
      confirmPassword: '',
      allowEmailing: true,
      phone: '',
      mobile: '',
      allowTexting: true,
      address1: '',
      address2: '',
      city: '',
      province: '',
      zipCode: '',
      initialForms: [],
      forms: [],
      memberships: [],
      createErrorMessage: false,
      termsAgreement: false,
      caslConsent: false
    };
    this.onChange = this.onChange.bind(this);
    this.onCheck = this.onCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddForm = this.handleAddForm.bind(this);
    this.handleRemoveForm = this.handleRemoveForm.bind(this);
    this.listToSelectOption = this.listToSelectOption.bind(this);
    this.diabledForm = this.diabledForm.bind(this);
    this.handleDynamicFormNameChange = this.handleDynamicFormNameChange.bind(this);
    this.handleDynamicFormIdChange = this.handleDynamicFormIdChange.bind(this);
  }

  componentWillReceiveProps(props) {
    var initialMemberships = []
    var initialForms = []
    if (this.props.usef) {
      initialMemberships = initialMemberships.concat([{name: "United States Equestrian Federation", number: this.props.usef}]),
      initialForms = initialForms.concat([this.diabledForm(1, "United States Equestrian Federation", this.props.usef)])
    }
    if (this.props.fei) {
      initialMemberships = initialMemberships.concat([{name: "Fédération Équestre Internationale", number: this.props.fei}]),
      initialForms = initialForms.concat([this.diabledForm(2, "Fédération Équestre Internationale", this.props.fei)])
    }
    if (this.props.ec) {
      initialMemberships = initialMemberships.concat([{name: "Equestrian Canada", number: this.props.ec}]),
      initialForms = initialForms.concat([this.diabledForm(3, "Equestrian Canada", this.props.ec)])
    }
    this.setState({ 
      memberships: initialMemberships,
      initialForms: initialForms
    });
  }

  diabledForm(id,name,number) {
    return  <div key={id} >
              <div className="control-group select optional user_equine_associations_name">
                <label className="select optional control-label">{I18n.t("activerecord.attributes.equine_association.name")}</label>
                <div className="controls">
                   <input className="string optional" type="text" disabled={true} placeholder={name} />
                </div>
              </div>
              <div className="control-group string optional user_equine_associations_number">
                <label className="string optional control-label">{I18n.t("activerecord.attributes.equine_association.number")}</label>
                <div className="controls">
                  <input className="string optional" type="text" disabled={true} placeholder={number} />
                </div>
              </div>
            </div>;
  }

  listToSelectOption(x) {
    return <option key={x}>{x}</option>
  }

  onChange(e) {
    const state = this.state;
    state[e.target.id] = e.target.value;
    this.setState(state);
  }

  onCheck(e) {
    // console.log(e.target.checked)
    const state = this.state;
    state[e.target.id] = e.target.checked;
    this.setState(state);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.termsAgreement && this.state.caslConsent) {
      $.ajax({
          url: '/registrants',
          type: 'POST',
          async: false,
          data: { 
            registrant: {
              company_name: this.state.companyName,
              contact_name: this.state.contactName,
              tax_number: this.state.taxId,
              email: this.state.email,
              password: this.state.password,
              allow_emailing: this.state.allowEmailing,
              phone: this.state.phone.replace(/\D/g,''),
              mobile: this.state.mobile.replace(/\D/g,''),
              allow_texting: this.state.allowTexting,
              address_attributes: {
                line1: this.state.address1,
                line2: this.state.address2,
                city: this.state.city,
                province: this.state.province,
                postal_code: this.state.zipCode,
                addressable_type: "Comapny"
              },
              equine_associations_attributes: this.state.memberships.filter(function(el) {return el.name !== I18n.t("activerecord.attributes.company.select_organization")}),
              is_company: true
            }
          },
          success: (response) => {
            window.location = response.url
          },
          error: (response) => {
            this.setState({ createErrorMessage: response.responseJSON.join(", ") })
          }
      });
    } else if (!this.state.termsAgreement) {
      this.setState({ createErrorMessage: I18n.t("exhibitor.terms_continue") })
    } else {
      this.setState({ createErrorMessage: I18n.t("exhibitor.casl_continue") })
    }
  }

  handleDynamicFormNameChange(e, key) {
    var memberships = this.state.memberships;
    memberships[key].name = e;
    this.setState(memberships)
  }

  handleDynamicFormIdChange(e, key) {
    var memberships = this.state.memberships;
    memberships[key].number = e;
    this.setState(memberships)
  }

  handleAddForm() {
    var memberships = this.state.memberships;
    const organizationList = [I18n.t("activerecord.attributes.company.select_organization"),
      I18n.t("equine_association.associations.ontario_equestrian"),
      "Cheval Québec",
      I18n.t("equine_association.associations.alberta"),
      I18n.t("equine_association.associations.new_brunswick"),
      I18n.t("equine_association.associations.british_columbia"),
      I18n.t("equine_association.associations.nova_scotia"),
      I18n.t("equine_association.associations.island"),
      I18n.t("equine_association.associations.manitoba"),
      I18n.t("equine_association.associations.saskatchewan"),
      I18n.t("equine_association.associations.newfoundland"),
      I18n.t("equine_association.associations.yukon"),
      I18n.t("equine_association.associations.ontario_hunter"),
      I18n.t("equine_association.associations.trillium"),
      I18n.t("equine_association.foreign")].map(this.listToSelectOption);
    const key = this.state.forms.length + this.state.initialForms.length
    memberships[key] = {name: "", number: ""}
    this.setState(memberships)
    this.setState({
      forms: this.state.forms.concat([
        <DynamicMembershipForm
          key={key}
          keyId={key}
          fieldNames={[I18n.t("activerecord.attributes.equine_association.name"), I18n.t("activerecord.attributes.equine_association.number")]}
          organizationList={organizationList}
          onNameChange={this.handleDynamicFormNameChange}
          onIdChange={this.handleDynamicFormIdChange} />
      ])
    });
  }

  handleRemoveForm() {
    this.setState({ 
      forms: this.state.forms.slice(0,-1),
      memberships: this.state.memberships.slice(0,-1)
    });
  }

  render() {
    return (
      <div className="form-horizontal">
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="span6" stylename="min-width: 420px;">
              <h4>
                <strong>
                  {I18n.t("exhibitor.company_information_label")}
                </strong>
              </h4>
              <div className="control-group string required company_name">
                <label className="string required control-label">
                  <abbr title="required">*</abbr>&nbsp;{I18n.t("company_name")}
                </label>
                <div className="controls">
                  <input className="string required" required="required" type="text" value={this.state.companyName} onChange={this.onChange} id="companyName"/>
                </div>
              </div>
              <div className="control-group string contact_name">
                <label className="string control-label">{I18n.t("activerecord.attributes.company.contact_name")}</label>
                <div className="controls">
                  <input className="string" type="text" value={this.state.contactName} onChange={this.onChange} id="contactName"/>
                </div>
              </div>
              <div className="control-group tax_id">
                <label className="string control-label">{I18n.t("activerecord.attributes.company.tax_id")}</label>
                <div className="controls">
                  <input className="string" type="text" value={this.state.taxId} onChange={this.onChange} id="taxId"/>
                </div>
              </div>
              <div className="control-group email required user_email">
                <label className="email required control-label">
                  <abbr title="required">*</abbr>{I18n.t("email")}
                </label>
                <div className="controls">
                  <input className="string email required" required="required" type="email" value={this.state.email} onChange={this.onChange} id="email"/>
                </div>
              </div>
              <div className="control-group password required user_password">
                <label className="password required control-label">
                  <abbr title="required">*</abbr> {I18n.t("sign_in_page.password")}
                </label>
                <div className="controls">
                   <input className="password required" required="required" type="password" minLength="8"
                    value={this.state.password} onChange={this.onChange} id="password" />
                </div>
              </div>
              <div className="control-group password required user_password_confirmation">
                <label className="password required control-label">
                  <abbr title="required">*</abbr>{I18n.t("activerecord.attributes.user.password_confirmation")}
                </label>
                <div className="controls">
                  <input className="password required" required="required" type="password" minLength="8"
                   value={this.state.confirmPassword} onChange={this.onChange} id="confirmPassword" />
                </div>
              </div>
              <div className="control-group boolean optional user_allow_emailing">
                <label className="boolean optional control-label">{I18n.t("simple_form.hints.user.allow_emailing")}</label>
                <div className="controls">
                  <input type="checkbox" checked={this.state.allowEmailing} onChange={this.onCheck} id="allowEmailing"/>
                  <p className="help-block"> {I18n.t("exhibitor.warning_uncheck_this_box")}</p>
                </div>
              </div>
              <div className="control-group tel optional user_phone">
                <label className="tel optional control-label" >{I18n.t("activerecord.attributes.user.phone")}</label>
                <div className="controls">
                  <InputMask className="string tel optional"  type="tel" value={this.state.phone} onChange={this.onChange} id="phone" mask={"(999)999-9999"}/>
                </div>
              </div>
              <div className="control-group string required user_mobile">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.mobile")}
                </label>
                <div className="controls">
                  <InputMask className="string required" type="text" required="required" value={this.state.mobile} onChange={this.onChange} id="mobile" mask={"(999) 999-9999"}/>
                </div>
              </div>
              <div className="control-group boolean optional user_allow_texting">
                <label className="boolean optional control-label">{I18n.t("activerecord.attributes.user.allow_texting")}</label>
                <div className="controls">
                  <input type="checkbox" checked={this.state.allowTexting} onChange={this.onCheck} id="allowTexting"/>
                  <p className="help-block">{I18n.t("user.will_not_recieve_messages_warning")}</p>
                </div>
              </div>
              <div className="row">
                <div className="span12">
                  <div className="control-group boolean optional termsAgreement">
                    <div className="controls">
                      <label className="checkbox">
                        <input type="checkbox" checked={this.state.termsAgreement} onChange={this.onCheck} id="termsAgreement"/> {I18n.t("exhibitor.terms_agree", {terms_link: ""})} <a target="_blank" href="/terms">{I18n.t("terms_link")}</a>
                      </label>
                    </div>
                  </div>
                  <div className="control-group boolean optional caslConsent">
                    <div className="controls">
                      <label className="checkbox">
                        <input type="checkbox" checked={this.state.caslConsent} onChange={this.onCheck} id="caslConsent"/> {I18n.t("exhibitor.casl_agree", {casl_link: ""})} <a target="_blank" href="/casl">{I18n.t("exhibitor.casl")}</a>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="span6">
              <br/>
              <br/>
              <div className="control-group string required user_address_line1">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.line1")}
                </label>
                <div className="controls">
                  <input className="string required" required="required" type="text" value={this.state.address1} onChange={this.onChange} id="address1"/>
                </div>
              </div>
              <div className="control-group string optional user_address_line2">
                <label className="string optional control-label">{I18n.t("activerecord.attributes.address.line2")}</label>
                <div className="controls">
                  <input className="string optional" type="text" value={this.state.address2} onChange={this.onChange} id="address2"/>
                </div>
              </div>
              <div className="control-group string required user_address_city">
                <label className="string required control-label" >
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.city")}
                </label>
                <div className="controls">
                  <input className="string required" required="required" type="text" value={this.state.city} onChange={this.onChange} id="city"/>
                </div>
              </div>
              <div className="control-group select required user_address_province">
                <label className="select required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.province")}
                </label>
                <div className="controls">
                  <select required="required" value={this.state.province} onChange={this.onChange} id="province">
                    <option key="0"></option>
                    {this.props.provincess.map(this.listToSelectOption)}
                  </select>
                </div>
              </div>
              <div className="control-group string required user_address_postal_code">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.postal_code")}
                </label>
                <div className="controls">
                  <input className="string required" required="required" type="text" value={this.state.zipCode} onChange={this.onChange} id="zipCode"/>
                </div>
              </div>
              <div>
                <strong>{I18n.t("equine_association.header")}</strong>
                {this.state.initialForms}
                {this.state.forms}
                {this.state.memberships.length > this.state.initialForms.length ?
                  <div>
                    <a className="btn btn-danger" onClick={this.handleRemoveForm}>{I18n.t("equine_association.remove")}</a>
                    <br/>
                    <br/>
                  </div>
                  : undefined}
                <a className="btn btn-success" onClick={this.handleAddForm}>{I18n.t("equine_association.add")}</a>
              </div>
            </div>
          </div>
          {this.state.createErrorMessage ? 
            <ErrorMessage message={this.state.createErrorMessage} />
            :undefined
          }
          <p>
            <strong> {I18n.t("exhibitor.final_create_notice")}
            </strong>
          </p>
          <a className="btn btn-success" href="/">{I18n.t("home_link")}</a>
          <span> </span>
          <input className="btn btn-primary" type="submit" value= {I18n.t("exhibitor.create_exhibitor_button")}/>
        </form>
      </div>
    );
  }
}
